export default
{
	model         : 'ShowPosition'.toLowerCase(),
	title         : 'Liste des placements',
	link          : '/configuration/placements',
	creation_link : '/configuration/nouveau-placement',
	creation_label: 'Nouveau placement',
	header        : ['Libellé'],
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/placements/',
	searched_prop: 'label'
}